import { Switch } from "antd";
import { useMapboxContext } from "../mapbox/context/mapbox-context";

interface ISwichLayer { 
    layerId: string;
    visible: boolean;
}

const SwitchLayer = (props: ISwichLayer) => {
    const { styleLayers, setStyleLayers} = useMapboxContext();
    const { layerId, visible } = props; 
   
    const toggleLayerVisibility = () => {
           const newStyleLayers = styleLayers.map((layer: any) => {
           return layer.layerId === layerId ? { ...layer, visible: !layer.visible } : layer 
           }
         )
        setStyleLayers(newStyleLayers); 
      };

    return (<Switch onChange={()=>{toggleLayerVisibility()}} checked={visible} />)
}

export default SwitchLayer;